var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// @ts-ignore
import PictureInPicture from '../../features/stream-effects/picture-in-picture/PictureInPicture.js';
// @ts-ignore
import { NOTIFICATION_TIMEOUT_TYPE, showErrorNotification } from '../notifications';
import { SET_PICTURE_IN_PICTURE_ENABLED, SET_PICTURE_IN_PICTURE_OBJECT } from './actionTypes';
import { isPictureInPictureEnabled } from './functions';
import logger from './logger';
/**
 * Updates the noise suppression active state.
 *
 * @param {boolean} enabled - Is noise suppression enabled.
 * @returns {{
 *      type: SET_FACE_RECOGNITION_ENABLED,
 *      enabled: boolean
 * }}
 */
export function setPictureInPictureEnabledState(pip) {
    return {
        type: SET_PICTURE_IN_PICTURE_ENABLED,
        pip
    };
}
export function setPictureInPictureObject(pipObject) {
    return {
        type: SET_PICTURE_IN_PICTURE_OBJECT,
        pipObject
    };
}
/**
 *  Enabled/disable noise suppression depending on the current state.
 *
 * @returns {Function}
 */
export function togglePictureInPicture() {
    return (dispatch, getState) => {
        if (isPictureInPictureEnabled(getState())) {
            dispatch(setPictureInPictureEnabled(false));
        }
        else {
            dispatch(setPictureInPictureEnabled(true));
        }
    };
}
/**
 * Attempt to enable or disable noise suppression using the {@link NoiseSuppressionEffect}.
 *
 * @param {boolean} pip - Enable or disable noise suppression.
 * setPictureInPictureEnabled
 * @returns {Function}
 */
export function setPictureInPictureEnabled(pip) {
    return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
        const state = getState();
        const pictureInPictureEnabled = isPictureInPictureEnabled(state);
        try {
            if (pip && !pictureInPictureEnabled) {
                const pipObject = new PictureInPicture(dispatch);
                dispatch(setPictureInPictureObject(pipObject));
                pipObject.startEffect();
                dispatch(setPictureInPictureEnabledState(true));
            }
            else if (!pip && pictureInPictureEnabled) {
                const { pipObject } = getState()['features/picture-in-picture'];
                pipObject.stopEffect();
                dispatch(setPictureInPictureObject({}));
                dispatch(setPictureInPictureEnabledState(false));
            }
            else {
                logger.warn(`PIP enabled state already: ${pip}`);
            }
        }
        catch (error) {
            logger.error(`Failed to set PIP enabled to: ${pip}`, error);
            dispatch(showErrorNotification({
                titleKey: 'notify.pipFailedTitle'
            }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
        }
    });
}
